import {DatesUtils} from "../../commons/datesUtils";

/**
 * Controla la directiva para ver y añadir comenarios en las tareas.
 */
ComentariosCtrl.$inject = ['$log', '$scope', '$http', 'ComentarioTarea', 'ComentarioIncidencia', '$timeout', '$filter', '$q', 'mentioUtil', '$sce'];
export default function ComentariosCtrl($log, $scope, $http, ComentarioTarea, ComentarioIncidencia, $timeout, $filter, $q, mentioUtil, $sce) {

    let vm = this;
    let currentUserId = Sigo.user.user_id;
    let DEFAULT_NUMBER_COMMENTS = 5;

    vm.loading = true;
    vm.comments = [];
    vm.editId = null;
    vm.showMessageEditOk = null;
    vm.comment = "";
    vm.commentEdit = "";
    vm.showingAll = false;
    vm.commentsHidden = [];
    vm.urlQuote = `${Sigo.var.path}/api/v2/${(vm.model == "tarea" ? "tareas" : "incidencias")}/comments/quote/${vm.modelId}`;

    vm.formatComment = formatComment;
    vm.formatUserComment = formatUserComment;
    vm.addComment = addComment;
    vm.editComment = editComment;
    vm.updateComment = updateComment;
    vm.userCanEdit = userCanEdit;
    vm.cancelEditComment = cancelEditComment;
    vm.showAllComments = showAllComments;
    vm.update = () => {
        loadComments(vm.model, vm.modelId)
    };

    loadComments(vm.model, vm.modelId);

    function formatComment(comment) {
        let citasTareas = comment.match(/(^#|#)([a-z0-9]+)/gi);
        if (citasTareas != null)
            citasTareas.forEach((element) => {
                let url = Sigo.var.path + '/obras/unica/' + element.substr(1);
                let link = '<a href="' + url + '" target="_blank" class="citaTarea">' + element + '</a>';
                comment = comment.replace(element, link);
            });

        let citasComentarios = comment.match(/(@[a-z0-9][A-Za-z0-9_.]*)/ig);
        if (citasComentarios != null)
            citasComentarios.forEach((element) => {
                let link = '<span class="citaUsuario">' + element + '</span>';
                comment = comment.replace(element, link);
            });

        return $sce.trustAsHtml(comment);
    }

    function formatUserComment(comment) {
        return $sce.trustAsHtml(comment.usuario.codusuario + " [" + comment.usuario.nombre + " "
            + comment.usuario.apellidos + "] <span class='hour' title='" + DatesUtils.fullDate(comment.hora) + "'>"
            + DatesUtils.formatDate(comment.hora) + "</span>");
    }

    function userCanEdit(comment) {
        return comment.usuario_id == currentUserId;
    }

    function editComment(comment) {
        vm.editId = comment.id;
        vm.commentEdit = comment.comentario;
    }

    function cancelEditComment() {
        vm.editId = null;
        vm.commentEdit = "";
    }

    function showAllComments() {
        vm.showingAll = true;
        vm.commentsHidden = vm.commentsHidden.concat(vm.comments);
        vm.comments = vm.commentsHidden;
        vm.commentsHidden = [];
    }

    function loadComments(model, id) {
        vm.loading = true;
        vm.showingAll = false;
        vm.comments = [];
        vm.commentsHidden = [];

        let promise = model == 'tarea'
            ? ComentarioTarea.query({tareaId: id}).$promise
            : ComentarioIncidencia.query({incidenciaId: id}).$promise;

        promise
            .then((data) => {
                if (data.length == 0) return;
                if (data.length <= DEFAULT_NUMBER_COMMENTS) {
                    vm.comments = data;
                } else {

                    let limit = data.length - DEFAULT_NUMBER_COMMENTS;

                    vm.comments = data.slice(limit);
                    vm.commentsHidden = data.slice(0, limit);
                }
            })
            .finally(() => {
                vm.loading = false;
            })
    }

    function addComment(comment, model, id) {
        if (!vm.canAdd) return;
        if (comment == null || comment.length === 0) return;

        let params = {
            comentario: comment
        };

        let promise = model == 'tarea'
            ? ComentarioTarea.save({tareaId: id}, params).$promise
            : ComentarioIncidencia.save({incidenciaId: id}, params).$promise;

        promise.then(() => {
            loadComments(model, id);
            vm.comment = "";
        });
    }

    function updateComment(comment, model, id, changes) {
        if (!vm.canAdd) return;
        if (changes == null || changes.length === 0) return;

        let params = {
            comentario: changes
        };

        let promise = model == 'tarea'
            ? ComentarioTarea.update({tareaId: id, comentarioId: comment.id}, params).$promise
            : ComentarioIncidencia.update({incidenciaId: id, comentarioId: comment.id}, params).$promise;

        promise.then(() => {
            cancelEditComment();
            vm.comments.forEach((commentSearch) => {
                if (comment.id == commentSearch.id) comment.comentario = changes;
            });
            vm.showMessageEditOk = comment.id;
            $timeout(function () {
                vm.showMessageEditOk = null;
            }, 2000);
        });
    }
}